import { Link } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import {
  CryptoIcon,
  CurrencyValue,
  EtherScanPictogram,
  Flex,
  Heading,
  WalletAddress,
  DataTable,
  RelativeDateTime
} from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import { TOKEN_ADDRESS_MAPPING } from '@/constants';

export default function TokenEventsTable({ data, sorting, pagination }) {
  const { address } = useParams();
  const columns: TableColumn[] = [
    {
      header: 'Wallet Address',
      getCell: (row) => (
        <Link to={`/tokens/${address}/holders/${row.wallet_address}`}>
          <WalletAddress
            address={row.wallet_address}
            options={{ sizes: { blockie: '0' } }}
          />
        </Link>
      )
    },
    {
      header: 'Event',
      getCell: (row) => row.event
    },
    {
      header: (
        <Flex display="flex" flexDirection="row" alignItems="center" gap="3xs">
          Amount
          <CryptoIcon
            name={TOKEN_ADDRESS_MAPPING[address]}
            address={address}
            size="0"
          />
        </Flex>
      ),
      getCell: (row) => (
        <CurrencyValue
          value={row.amount}
          options={{
            currency: '',
            trend: true,
            iconSize: '1'
          }}
        />
      ),
      cellAlign: 'flex-end',
      headerAlign: 'flex-end',
      sortingField: 'amount'
    },
    {
      header: 'Time',
      getCell: (row) => (
        <Flex gap={['xs', '2xs']} color="muted">
          <RelativeDateTime value={row.datetime} />
          <a
            href={`https://etherscan.io/tx/${row.tx_hash}`}
            target="_blank"
            rel="noreferrer">
            <EtherScanPictogram size="0" />
          </a>
        </Flex>
      ),
      cellAlign: 'flex-end',
      headerAlign: 'flex-end',
      sortingField: 'order_index'
    }
  ];

  return (
    <>
      <Flex justifyContent="space-between">
        <Heading size="2">Events</Heading>
        <Flex color="muted" fontSize="-1" justifyContent="center">
          Only showing events for the last 30 days
        </Flex>
      </Flex>
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.order_index + row.wallet_address}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    </>
  );
}
